export default __webpack_public_path__ + "static/media/2021 knife block B side.16a6d0f4.png";